<template>
  <div>
    <v-row align="center" justify="center" style="height:100vh">
        <v-col cols="4">
            <v-card class="pa-5">
                <p class="text-center">Enter your Credentials</p>
                <v-text-field
                outlined
                dense
                v-model="username"
                label="Username"
                >

                </v-text-field>
                <v-text-field
                outlined
                dense
                v-model="password"
                label="Password"
                >

                </v-text-field>

                <v-btn block color="green" @click="login" dark>
                    Login
                </v-btn>
            </v-card>
            <p class="mb-5"></p>
            <router-link  style="text-decoration:none" to="/"> <p class="text-center">Return Home</p></router-link>
        </v-col>
       
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            username:"",
            password:""
        }
    },
    methods:{
        login(){
            axios.get('https://zaastry-node.herokuapp.com/admin').then(res=>{
                let user=res.data
                
                for(var i=0;i<user.length;i++){
                    if(user[i].username==this.username && user[i].password==this.password){
                        localStorage.setItem("admin",true)
                        localStorage.setItem("teams",JSON.stringify(user[i]))
                        this.$store.commit("setAdmin",true)

                        this.$router.push("/dashboard")
                    }
                }
            })
        }
    }
}
</script>

<style>

</style>